import { useTranslation } from "react-i18next";
export default function SearchBox(props) {
  const { t } = useTranslation("survey");

  function onInput(e) {
    props.setKeyword(e.target.value);
  }

  return (
    <div className="search-box">
      <label htmlFor="products-search-box" className="tag">
        {t("survey.product_selection.search")}:
      </label>
      <input
        type="text"
        id="products-search-box"
        className="sv_q_text_root"
        onInput={onInput}
      />
    </div>
  );
}
